import { CalendarClock, CheckCircle2, Lock, Mail, Send } from "lucide-react";
import { EJEMPLO } from "../content";
import { DatosEjemplo, MarcoApp, Pill, clp, clp2 } from "./MarcoApp";

// Un estado de la app por paso del mes. Cada uno es un fragmento de pantalla real de SEBBIA con
// datos de ejemplo, no una ilustración.

const Fila = ({ children, className = "" }) => (
  <div className={`flex items-center justify-between gap-3 border-t border-slate-100 px-3 py-2.5 text-xs ${className}`}>{children}</div>
);

const Cobrar = () => (
  <MarcoApp titulo="Anuncios · Envíos programados">
    <div className="space-y-3 p-4">
      <div className="rounded-xl border-l-4 border-l-indigo-500 bg-white p-3 ring-1 ring-inset ring-slate-200/60">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-50"><CalendarClock className="h-4 w-4 text-indigo-600" /></span>
            <div>
              <p className="text-xs font-bold text-slate-800">Aviso de cobro</p>
              <p className="text-[11px] text-slate-500">Día 1 de cada mes · 38 arrendatarios</p>
            </div>
          </div>
          <Pill tono="indigo">Programado</Pill>
        </div>
      </div>
      <div className="overflow-hidden rounded-xl bg-white ring-1 ring-inset ring-slate-200/60">
        <p className="bg-slate-50 px-3 py-2 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Últimos envíos</p>
        {[
          ["1 Sep 2026", "38 enviados"],
          ["1 Ago 2026", "37 enviados"],
          ["1 Jul 2026", "37 enviados"],
        ].map(([f, n]) => (
          <Fila key={f}><span className="flex items-center gap-2 text-slate-700"><Mail className="h-3.5 w-3.5 text-slate-400" />{f}</span><Pill tono="pagado">{n}</Pill></Fila>
        ))}
      </div>
      <DatosEjemplo />
    </div>
  </MarcoApp>
);

const Registrar = () => (
  <MarcoApp titulo="Registrar pago · Depto. 1204">
    <div className="space-y-3 p-4">
      <div className="grid grid-cols-2 gap-2">
        {[
          ["Arrendatario", "J. Pérez"],
          ["Vencimiento", "5 Sep 2026"],
          ["Fecha de pago", "8 Sep 2026"],
          ["Monto", clp(EJEMPLO.arriendo)],
        ].map(([k, v]) => (
          <div key={k} className="rounded-xl bg-white px-3 py-2 ring-1 ring-inset ring-slate-200/60">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">{k}</p>
            <p className="text-xs font-semibold tabular-nums text-slate-800">{v}</p>
          </div>
        ))}
      </div>
      <div className="rounded-xl border-l-4 border-l-amber-400 bg-amber-50/60 px-3 py-2.5 ring-1 ring-inset ring-amber-100">
        <div className="flex items-center justify-between text-xs">
          <span className="font-semibold text-amber-800">Multa por atraso · 3 días</span>
          <span className="font-bold tabular-nums text-amber-800">+{clp(22700)}</span>
        </div>
        <p className="mt-0.5 text-[11px] text-amber-700/80">Calculada con la fecha real de pago.</p>
      </div>
      <div className="flex items-center justify-between rounded-xl bg-white px-3 py-2.5 ring-1 ring-inset ring-slate-200/60">
        <span className="flex items-center gap-2 text-xs font-semibold text-slate-700"><CheckCircle2 className="h-4 w-4 text-emerald-500" />Voucher para el arrendatario</span>
        <Pill tono="pagado">Listo</Pill>
      </div>
      <DatosEjemplo />
    </div>
  </MarcoApp>
);

const Liquidar = () => (
  <MarcoApp titulo={`Liquidación · ${EJEMPLO.periodo}`}>
    <div className="space-y-3 p-4">
      <div className="flex flex-wrap gap-2">
        <Pill tono="indigo">UF día 9 · {clp2(EJEMPLO.uf)}</Pill>
        <Pill tono="neutro">Honorarios {EJEMPLO.honorariosPct}% sobre lo recaudado</Pill>
      </div>
      <div className="overflow-hidden rounded-xl bg-white ring-1 ring-inset ring-slate-200/60">
        <Fila className="border-t-0"><span className="text-slate-600">Arriendo ({String(EJEMPLO.arriendoUf).replace(".", ",")} UF)</span><span className="font-semibold tabular-nums text-slate-900">{clp(EJEMPLO.arriendo)}</span></Fila>
        <Fila><span className="text-slate-600">Honorarios</span><span className="font-semibold tabular-nums text-slate-900">−{clp(EJEMPLO.honorarios)}</span></Fila>
        <Fila><span className="text-slate-600">Mantención</span><span className="font-semibold tabular-nums text-slate-900">−{clp(EJEMPLO.mantencion)}</span></Fila>
        <Fila className="bg-indigo-50/60"><span className="font-bold text-indigo-900">Neto al propietario</span><span className="font-display font-extrabold tabular-nums text-indigo-900">{clp(EJEMPLO.neto)}</span></Fila>
      </div>
      <div className="flex items-center justify-between rounded-xl bg-white px-3 py-2.5 ring-1 ring-inset ring-slate-200/60">
        <span className="flex items-center gap-2 text-xs font-semibold text-slate-700"><Lock className="h-4 w-4 text-indigo-500" />Período cerrado</span>
        <span className="text-[11px] text-slate-500">Cifras congeladas</span>
      </div>
      <DatosEjemplo />
    </div>
  </MarcoApp>
);

const Rendir = () => (
  <MarcoApp titulo={`Nómina de pagos · ${EJEMPLO.periodo}`}>
    <div className="space-y-3 p-4">
      <div className="rounded-xl bg-white px-3 py-2.5 ring-1 ring-inset ring-slate-200/60">
        <div className="flex items-center justify-between text-xs">
          <span className="flex items-center gap-2 font-semibold text-slate-700"><Send className="h-4 w-4 text-indigo-500" />Liquidaciones enviadas</span>
          <span className="font-bold tabular-nums text-slate-900">38 de 38</span>
        </div>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100"><div className="h-full w-full rounded-full bg-emerald-500" /></div>
      </div>
      <div className="overflow-hidden rounded-xl bg-white ring-1 ring-inset ring-slate-200/60">
        {[
          ["M. González", EJEMPLO.neto],
          ["Inversiones Ríos", 1184320],
          ["C. Muñoz", 498760],
          ["A. Soto", 712905],
        ].map(([n, v], i) => (
          <Fila key={n} className={i === 0 ? "border-t-0" : ""}>
            <span className="text-slate-700">{n}</span>
            <span className="flex items-center gap-2"><span className="font-semibold tabular-nums text-slate-900">{clp(v)}</span><Pill tono="pagado">PDF enviado</Pill></span>
          </Fila>
        ))}
      </div>
      <DatosEjemplo />
    </div>
  </MarcoApp>
);

const POR_PASO = { cobrar: Cobrar, registrar: Registrar, liquidar: Liquidar, rendir: Rendir };

export const MockupPaso = ({ paso }) => {
  const Componente = POR_PASO[paso] || Cobrar;
  return <Componente />;
};
